<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .candidates-list-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 25;
    pointer-events: auto;

    .candidates-list {
      position: absolute;
      top: calc(100% / 3 - 20px);
      left: 12px;
      right: 12px;
      max-height: 250px;
      background-color: rgba(0, 0, 0, 0.95);
      backdrop-filter: blur(2rem);
      border-radius: 8px;
      overflow-y: auto;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
      pointer-events: auto;

      .candidate-item {
        align-items: center;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        gap: utils.in_rem(12px);
        padding: utils.in_rem(12px);
        transition: background-color 0.15s ease;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid colors.get(interfaceTransparentWhite_15);

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: colors.get(interfaceTransparentWhite_15);
        }

        .candidate-info {
          display: flex;
          flex: 1;
          flex-direction: column;
          gap: utils.in_rem(2px);
          min-width: 0;

          .candidate-name {
            color: colors.get(textWhite);
            @include mixins.body2;
            font-weight: 500;
            line-height: 1.2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .candidate-phone {
            color: colors.get(interfaceTransparentWhite_90);
            @include mixins.body4;
            line-height: 1.2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .candidate-job {
            color: colors.get(interfaceTransparentWhite_70);
            @include mixins.body4;
            line-height: 1.2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .no-results {
        padding: utils.in_rem(16px);
        text-align: center;
        color: colors.get(interfaceTransparentWhite_70);
        @include mixins.body3;
      }
    }
  }
</style>

<script>
  import DiallerAvatar from "./DiallerAvatar.svelte";
  import { getPhone } from "../utils/phoneUtils.js";

  let {
    candidates = [],
    isVisible = false,
    onSelectCandidate = () => {},
    searchValue = "",
  } = $props();

  // Format job info for display
  const formatJobInfo = (candidate) => {
    const role = candidate?.role || "";
    const company = candidate?.company || "";
    return !role && !company ? "" : `${role} @ ${company}`.trim();
  };
</script>

{#if isVisible}
  <div class="candidates-list-wrapper">
    <div class="candidates-list">
      {#if candidates?.length > 0}
        {#each candidates as candidate}
          <button
            class="candidate-item"
            type="button"
            onclick={() => onSelectCandidate(candidate)}
          >
            <DiallerAvatar
              firstName={candidate.firstName ||
                candidate.name?.split(" ")[0] ||
                ""}
              lastName={candidate.lastName ||
                candidate.name?.split(" ").slice(1).join(" ") ||
                ""}
              src={candidate.photo}
              size="small"
              state="candidate"
              alt={candidate.name || "Contact"}
            />
            <div class="candidate-info">
              <div class="candidate-name">
                {candidate.name || "Unknown"}
              </div>
              {#if formatJobInfo(candidate)}
                <div class="candidate-job">{formatJobInfo(candidate)}</div>
              {/if}
              <div class="candidate-phone">
                {getPhone(candidate, searchValue)}
              </div>
            </div>
          </button>
        {/each}
      {:else}
        <div class="no-results">No candidates found</div>
      {/if}
    </div>
  </div>
{/if}
